<script setup lang="ts">
const { t } = useI18n();
const { getItemById } = useItemsController();
const appStateStore = useAppStateStore();
const merchant = appStateStore.currentMerchant;
const route = useRoute();
const title = ref<string>("");
const imageUrl = ref<string>("");

useSeoMeta({
  title: () => title.value,
  description: `${t("main.marketplaceSEO.description.collectibleDetail")}`,
  ogType: "website",
  ogTitle: () => title.value,
  ogDescription: `${t("main.marketplaceSEO.description.collectibleDetail")}`,
  ogUrl: "https://gfal.market",
  ogImage: () => imageUrl.value,
  twitterCard: "summary_large_image",
  twitterSite: "@GFAL_Official",
  twitterTitle: () => title.value,
  twitterDescription: `${t(
    "main.marketplaceSEO.description.collectibleDetail"
  )}`,
  twitterImage: () => imageUrl.value,
});

const pages = computed(() => [
  { name: t("storeDetail.allGames"), href: "/", current: false },
  {
    name: `${t(`merchant.${merchant}`)} Consumables`,
    href: `/store/${item.value?.merchantId}`,
    current: false,
  },
  {
    name: item.value
      ? t(`${item.value?.translationId}.title`) +
        " " +
        t(`${item.value?.translationId}.subtitle`)
      : "",
    href: `/store/${item.value?.merchantId}/${item.value?.id}`,
    current: true,
  },
]);

const setSEO = (item: Item) => {
  if (item) {
    title.value = `${t(`${item.translationId}.title`)} ${t(
      `${item.translationId}.subtitle`
    )} | ${t(`main.merchant.${merchant}`)}`;
    imageUrl.value = getPortraitItemImage(item.imageId).replace("webp", "png");
  }
};

const { data: item, status } = await useAsyncData(
  `get${merchant}ItemById`,
  async () => {
    const id = route.params.id?.toString();
    if (!id) return {} as Item;
    const response = await getItemById(id, merchant);
    return response;
  },
  {
    default() {
      return {} as Item;
    },
    lazy: true,
  }
);

watch(
  item,
  (newItem) => {
    if (newItem) setSEO(newItem);
  },
  { immediate: true }
);
</script>

<template>
  <NuxtLinkLocale
    class="flex items-center my-7 cursor-pointer text-neutral-300 hover:text-primary-500"
    :to="pages[1]?.href">
    <NuxtIcon
      name="mdi:chevron-left"
      class="h-5 w-5 shrink-0"
      aria-hidden="true" />
    <p class="text-xl font-bold">{{ $t("main.storeDetail.backToList") }}</p>
  </NuxtLinkLocale>
  <div
    v-if="status === 'pending' || !appStateStore.areTidsLoaded"
    class="flex items-center justify-center">
    <LoaderCardDetail />
  </div>
  <CardItemDetail v-else-if="status === 'success' && item" :item="item" />
  <CommonNotFoundItem v-else />
</template>
